type WaveDividerProps = {
  className?: string;
};

export default function WaveDivider({ className = "" }: WaveDividerProps) {
  return (
    <div className={`w-full py-10 md:py-16 ${className}`} aria-hidden="true">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-2 px-8">
        <span className="block h-3 w-full rounded-[50%] border-t-2 border-primary-500/80" />
        <span className="block h-3 w-[90%] self-center rounded-[50%] border-t-2 border-accent-500/80" />
        <span className="block h-3 w-[96%] self-center rounded-[50%] border-t-2 border-secondary-500/80" />
      </div>
    </div>
  );
}